var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isVisitor && _vm.isEnabled)?_c('div',[_c('SiteNavFull',{attrs:{"active":_vm.active,"links":_vm.links,"advisor":_vm.advisor,"features":_vm.features,"open":_vm.open},on:{"toggled":_vm.toggle,"sized":_vm.updateWidth}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }